<template lang="pug">
  section.center
    transition( name="fade" )
      .sc-container
        img( :src="screenshotImg" )
    transition( name="description" )
      .retry-container
        .title
          .year 2019
          .text Have a Good Year!
        .retry
          circle-btn(
            :text="resultStr",
            :isAlive="replayBtn.isAlive",
            @onClick="onClick"
          )
        .sns
          .menu
            .tweet( @click="onTwitterClick" )
              i( class="fab fa-twitter" )
            .facebook( @click="onFacebookClick" )
              i( class="fab fa-facebook" )

        .link
          a( href="https://sretks.com", target="_blank" ) SRETKS.com
</template>

<script>
import CircleBtn from "../CircleBtn";

export default {
  components: {
    CircleBtn
  },

  props: ["screenshotImg", "result"],

  data() {
    return {
      status: true,
      replayBtn: {
        isAlive: false
      }
    };
  },

  computed: {
    resultStr() {
      if (this.result) {
        return "PLAY AGAIN";
      } else {
        return "RETRY";
      }
    }
  },

  mounted() {
    this.replayBtn.isAlive = true;
  },

  methods: {
    onClick() {
      if (this.result) {
        this.$emit("onPlayAgainClick");
      } else {
        this.$emit("onRetryClick");
      }
    },

    onTwitterClick() {
      this.$emit("onTwitterClick");
    },

    onFacebookClick() {
      this.$emit("onFacebookClick");
    }
  }
};
</script>

<style scoped lang="scss">
.sc-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;

  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    position: absolute;
    width: calc(100% - 60px);
    height: calc(100% - 60px);
    object-fit: cover;
  }
}

.retry-container {
  position: absolute;
  width: 100%;
  height: 80%;
  z-index: 2;
  filter: drop-shadow(0px 0px 100px rgba(0, 0, 64, 1));

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .title {
    margin-bottom: 4rem;

    .year {
      font-family: "ELECNA", sans-serif;
      color: #fff;
      font-size: 32vw;
    }

    .text {
      margin-top: 1rem;
      font-family: "ELECNA", sans-serif;
      font-size: 8vw;
      color: #fff;
    }
  }

  .sns {
    height: 80px;
    margin-bottom: 2rem;

    .menu {
      display: flex;
      justify-content: center;
      align-items: center;

      .tweet,
      .facebook {
        i {
          font-size: 4rem;
          color: #fff;

          &:hover {
            opacity: 0.5;
          }
        }

        padding: 1rem;
      }
    }
  }

  .link {
    display: block;
    height: 40px;
    flex-basis: 0;

    a {
      display: block;
      font-size: 2rem;
      font-family: "ELECNA", sans-serif;
      color: #fff;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

@media screen and (min-width: 768px) {
  .retry-container {
    height: 60%;

    .title {
      .year {
        font-size: 8vw;
      }

      .text {
        font-size: 1.8vw;
      }
    }

    .sns {
      .sns-title {
        font-size: 1.8vw;
      }
    }
  }
}
</style>
